<template>
    <div class="form-group mt-2 mb-4">

        <div class="mb-4">
            <label class="form-label" for="iiko_actions">
                {{__t("DISCOUNT_PROGRAM")}}
            </label>

            <div class="" v-if="syrve_actions.length > 0">
                <v-select v-model="org_discount_program"
                          class="imc_reasons"
                          label="name"
                          :reduce="action => action.id"
                          id="iiko_actions"
                          :options="this.syrve_actions"
                          :filterable="false"
                >
                    <template slot="no-options">
                        {{__t("CHOICE_SYRVE_ACTION")}}
                    </template>

                    <template slot="option" slot-scope="option">
                        <div class="d-center">
                            <div>
                                {{ option.name }}
                            </div>
                            <div>
                                <small>
                                    {{option.id}}
                                </small>
                            </div>
                        </div>
                    </template>
                </v-select>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
    name: "syrve_discount",
    components: {vSelect},
    props : {
        org : {
            type:Object
        }
    },

    created() {
        if (parseInt(this.org.id) > 0) {
            this.load_syrve_discount();
        }
    },

    data() {
        return {
            is_load: false,
            syrve_actions : [],
        }
    },

    methods : {
        async load_syrve_discount() {
            await pos_api.get('/syrve/organizations/' + this.org.id +'/discount/program',{}).then(({data}) => {
                if (data.status === "operation_success") {
                    this.syrve_actions = data.data;
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },
    },

    computed : {
        org_discount_program : {
            get() {
                return this.org?.discount_program_id || null;
            },
            set (val) {
                console.log('set_new_program',val);
                this.org.discount_program_id = val;
            }
        }
    }

}
</script>



<style scoped>

</style>
